import { ArticleTableRow } from '../../../models/ArticleTableRow';

export const sortDocuments = (articles: ArticleTableRow[]): ArticleTableRow[] => {
  return Array.from(articles?.values()).sort((article1: ArticleTableRow, article2: ArticleTableRow): number => {
    const publishDate1 = article1.publishDate;
    const publishDate2 = article2.publishDate;
    return publishDate1.localeCompare(publishDate2);
  });
};
